import React from 'react';
import { Container } from 'reactstrap';
import PositionIdamanView from './Components/PositionIdamanView';

const PositionIdaman = () => {
  document.title = 'Position ID IDAMAN';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid className='px-0'>
          <PositionIdamanView />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PositionIdaman;
